import { Link, useLocation } from 'react-router-dom'
import logoText from '../assets/asterode-logo-text.svg'

interface HeaderProps {
  hidden?: boolean
}

const Header = ({ hidden = false }: HeaderProps) => {
  const location = useLocation()
  const isHome = location.pathname === '/'

  return (
    <header
      className={`fixed inset-x-0 top-0 z-40 border-b border-[var(--line-100)] bg-white backdrop-blur-sm transition-all duration-500 ${
        hidden ? 'pointer-events-none -translate-y-full opacity-0' : 'translate-y-0 opacity-100'
      }`}
    >
      <div className="container-shell">
        <div className="flex h-16 items-center justify-between gap-4 sm:h-[74px]">
          <Link to="/" className="group flex items-center">
            <img src={logoText} alt="Asterode" className="h-4 w-auto transition duration-200 group-hover:opacity-80 sm:h-5" />
          </Link>

          <nav className="hidden items-center gap-7 lg:flex">
            <a
              href={isHome ? '#why' : '/#why'}
              className="text-sm font-medium text-ink-600 transition hover:text-ink-500"
            >
              Why Asterode
            </a>
            <a
              href={isHome ? '#tour' : '/#tour'}
              className="text-sm font-medium text-ink-600 transition hover:text-ink-500"
            >
              How it Works
            </a>
            <a
              href={isHome ? '#features' : '/#features'}
              className="text-sm font-medium text-ink-600 transition hover:text-ink-500"
            >
              Features
            </a>
            <a
              href={isHome ? '#use-cases' : '/#use-cases'}
              className="text-sm font-medium text-ink-600 transition hover:text-ink-500"
            >
              Use Cases
            </a>
          </nav>

          <div className="flex items-center gap-2 sm:gap-3">
            <a
              href={isHome ? '#intro' : '/#intro'}
              className="btn-primary px-4 py-2 text-xs sm:px-5 sm:text-sm"
            >
              Download
            </a>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header

